import React from 'react';
import styled from 'styled-components';

import LandingContent from '../../components/LandingContent';
import colors from '../../utils/theme';
import { Modal } from 'semantic-ui-react';

// import img1 from '../../images/Special Offers/HOTEL PICS (17).png';
// import img2 from '../../images/Special Offers/EDUCATIONAL EXCURSIONS.png';
// import img3 from '../../images/Special Offers/CORPORATE OFFSITES.png';

import img10 from '../../images/Special Offers/new/1.jpg';
import img11 from '../../images/Special Offers/new/2.jpg';
import img12 from '../../images/Special Offers/new/12.jpg';
import img4 from '../../images/Special Offers/new/4.jpg';
import img5 from '../../images/Special Offers/new/5.jpg';
import img6 from '../../images/Special Offers/new/6.jpg';
import img7 from '../../images/Special Offers/new/7.jpg';
import img8 from '../../images/Special Offers/new/8.jpg';
import img9 from '../../images/Special Offers/new/9.jpg';

import Footer from '../../components/Footer';

// const icon1 = require('../../images/media/IMG_0383.png');
// const icon2 = require('../../images/media/IMG_0384 (2).png');
const icon1 = require('../../images/happening/p.jpg');
const icon2 = require('../../images/happening/s.jpg');
const icon3 = require('../../images/happening/magnolia.jpg');
const icon4 = require('../../images/happening/kp.jpg');
const icon5 = require('../../images/happening/mnp.jpg');
const icon6 = require('../../images/happening/ttc.jpg');
// const icon4 = require('../../images/happening/HOLI.png');
// const icon5 = require('../../images/happening/monsoon.jpg');
// const icon6 = require('../../images/happening/page-0001.jpg');
// const icon7 = require('../../images/happening/page-0002.jpg');
// const icon8 = require('../../images/happening/cool.jpg');


const Happening = () => {
  return (
    <React.Fragment>
      <LandingContent images={[img10, img11, img12, img4, img5, img6, img7, img8, img9]} />
      <Container>
        
        <SmallImages>
        
          <CustomModal dimmer={"blurring"} trigger={<Image src={icon4} />} style={{maxWidth: '600px'}} closeIcon>
            <Modal.Content>
              <StyledModalImage src={icon4} />
            </Modal.Content>
          </CustomModal>

          <CustomModal dimmer={"blurring"} trigger={<Image src={icon5} />} style={{maxWidth: '600px'}} closeIcon>
            <Modal.Content>
              <StyledModalImage src={icon5} />
            </Modal.Content>
          </CustomModal>

          <CustomModal dimmer={"blurring"} trigger={<Image src={icon6} />} style={{maxWidth: '600px'}} closeIcon>
            <Modal.Content>
              <StyledModalImage src={icon6} />
            </Modal.Content>
          </CustomModal>

          
        </SmallImages>
        <SmallImages>
        <CustomModal dimmer={"blurring"} trigger={<Image src={icon3} />} style={{maxWidth: '600px'}} closeIcon>
            <Modal.Content>
              <StyledModalImage src={icon3} />
            </Modal.Content>
          </CustomModal>
          <CustomModal dimmer={"blurring"} trigger={<Image src={icon1} />} style={{maxWidth: '600px'}} closeIcon>
            <Modal.Content>
              <StyledModalImage src={icon1} />
            </Modal.Content>
          </CustomModal>
        </SmallImages>

        
      </Container>
      <Footer />
    </React.Fragment>
  )
}

export default Happening;

const Container = styled.div`
  color: ${colors.primary};
  padding: 3rem 2rem;
  display: grid;
  grid-row-gap: 5rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
    grid-row-gap: 3rem;
  }
`;

const SmallImages = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

const Image = styled.img`
  max-height: 300px;
  width: auto;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    filter: blur(1px);
  }

  @media (max-width: 1024px) {
    max-height: 240px;
  }

  @media (max-width: 768px) {
    max-height: 180px;
  }

  @media (max-width: 480px) {
    max-height: 140px;
    margin: 0 auto;
  }
`;

const StyledModalImage = styled.img`
  width: 100%;
  max-width: 480px;
  height: auto;
  margin: auto;
  display: block;

  @media (max-width: 480px) {
    max-width: 95%;
  }
`;

const CustomModal = styled(Modal)`
  &&& {
    max-height: 85vh !important;
    background: transparent !important;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-top: 40px;
    width: auto !important;
  }
`;
